import * as React from 'react';
import SelectList from '../RBSelectList/RBSelectList';
import * as lookupService from '../../services/lookupService';
import { LookupValueTypes } from './lookupValueTypes';

export interface LookupValueSelectListProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  type: LookupValueTypes;
  typeName?: string;
  exclude?: string[];
  includeAll: boolean;
  datafield?: string;
}

const initialState = { data: [] };
type LookupValueSelectListState = Readonly<typeof initialState>;

export default class LookupValueSelectList extends React.Component<
  LookupValueSelectListProps,
  LookupValueSelectListState
> {
  _isMounted = true;
  public constructor(props: LookupValueSelectListProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchData(this.props.type, this.props.typeName);
  }

  removeExclusions(data, _this) {
    if (_this.props.exclude) {
      const excludedItems = _this.props.exclude.map(x => x.toLowerCase());
      const loopTill = data.length;
      for (var i = 0; i < loopTill - 1; i++) {
        if (
          excludedItems.includes(data[i].name.toLowerCase()) ||
          excludedItems.includes(data[i].value.toString().toLowerCase())
        ) {
          data.splice(i, 1);
        }
      }
    }
    if (_this._isMounted) {
      _this.setState({ data });
    }
  }

  fetchData(type, name) {
    const _this = this;
    let fullData: any = null;
    switch (type) {
      case LookupValueTypes.BYNAME:
        lookupService
          .typesByName(name, _this.props.includeAll)
          .then(function(data) {
            _this.removeExclusions(data, _this);
          });
        break;
      case LookupValueTypes.NOTIFICATION_TYPES:
        lookupService
          .getNotificationTypes(_this.props.includeAll)
          .then(function(data) {
            _this.removeExclusions(data, _this);
          });
        break;
      case LookupValueTypes.REPORT_TYPES:
        lookupService
          .getReportTypes(_this.props.includeAll)
          .then(function(data) {
            if (_this._isMounted) {
              _this.removeExclusions(data, _this);
            }
          });
        break;
      case LookupValueTypes.NOTIFICATION_STATUS_TYPES:
        lookupService
          .getNotificationStatusTypes(_this.props.includeAll)
          .then(function(data) {
            if (_this._isMounted) {
              _this.removeExclusions(data, _this);
            }
          });
        break;
      case LookupValueTypes.ALLTYPES:
        lookupService.getAllTypes(this.props.includeAll).then(function(data) {
          if (_this._isMounted) {
            _this.removeExclusions(data, _this);
          }
        });
      default:
        break;
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  public render() {
    return (
      <SelectList
        data={this.state.data}
        onChange={e => this.props.onChange(e)}
        value={this.props.value}
        data-field={this.props.datafield}
      />
    );
  }
}
